import { apiService } from '../services/api';

/**
 * Handles the Hybrid PDF Download logic:
 * 1. Attempts server-side download (LibreOffice).
 * 2. If 501 (Not Implemented), falls back to client-side generation (Mammoth).
 */
export async function handleHybridPdfDownload(taskId: number, versionId: number, fileName: string) {
    const toastId = `pdf-toast-${Date.now()}`;

    // Simple toast notification
    const showToast = (msg: string) => {
        const el = document.createElement('div');
        el.id = toastId;
        el.className = "fixed bottom-4 right-4 bg-gray-800 text-white px-4 py-2 rounded-lg shadow-lg z-50 text-sm animate-fade-in-up";
        el.textContent = msg;
        document.body.appendChild(el);
        setTimeout(() => el.remove(), 3000);
    };

    try {
        // 1. Try Backend Conversion First
        const blob = await apiService.downloadTaskVersionPdf(taskId, versionId);
        const url = window.URL.createObjectURL(blob);
        window.open(url, '_blank');
        setTimeout(() => window.URL.revokeObjectURL(url), 10000);
    } catch (err: any) {
        // 2. Check for 501 Not Implemented (LibreOffice Missing)
        if (err.message && err.message.includes("LIBREOFFICE_MISSING")) {
            showToast("⚠️ Server PDF conversion unavailable. Generating in browser...");

            try {
                // 3. Fallback: Fetch original DOCX and convert client-side
                // Dynamic import to avoid circular dependencies and reduce initial bundle size
                const { generateClientSidePdf } = await import('./clientPdfGenerator');

                const docxBlob = await apiService.getTaskVersionBlob(taskId, versionId);
                await generateClientSidePdf(docxBlob, fileName.replace('.docx', '.pdf'));

            } catch (fallbackErr: any) {
                console.error("Fallback PDF Generation failed:", fallbackErr);
                alert("Failed to generate PDF (both Server and Browser methods failed).");
            }
        } else {
            console.error("PDF Download Error:", err);
            alert(`Failed to download PDF: ${err.message}`);
        }
    }
}
